<template>
  <div class="warp">
    <navbarlogin :title="text"></navbarlogin>
    <div class="inner">
      <div class="person_box">
        <div class="inpititle">用户名</div>
        <div class="login_form">
          <input
            v-model="formdata.login_name"
            type="text"
            placeholder="请输入手机号/用户名"
          />
        </div>
        <div class="inpititle">密码</div>
        <div class="login_form">
          <input
            v-model="formdata.password"
            type="password"
            placeholder="请输入密码"
          />
        </div>
        <van-loading class="login_btn2" v-if="load" type="spinner"
          >加载中...</van-loading
        >
        <div class="login_btn">
          <van-button
            class="loginbtn"
            color="#64a5ff"
            @click.prevent="handleLogin()"
            size="18"
            >登录</van-button
          >
          <div class="dengl" @click="zhuce">注册</div>
          <!-- <div class="weixin" @click="weixin_login">
            <img src="@/assets/weixin.png" alt="">
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "../api/index";
import navbarlogin from "./NavBarlogin";
import VueEvent from "../model/VueEvent";
import Vue from "vue";
import { Button } from "vant";
import { Notify } from "vant";
import { Loading } from "vant";

Vue.use(Loading);
Vue.use(Notify);
Vue.use(Button);
import { Swipe, SwipeItem } from "vant";

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  components: {
    navbarlogin,
  },
  data() {
    return {
      formdata: {
        login_name: "",
        password: "",
      },
      load: false,
      text: "登录",
    };
  },
  mounted() {},
  methods: {
    goshouye() {
      this.$router.push({ path: "/" });
    },
    async handleLogin() {
      this.load = true;
      if (!this.formdata.login_name) {
        this.$notify("手机号不能为空");
        this.load = false;
        return;
      }
      if (!this.formdata.password) {
        this.$notify("密码不能为空");
        this.load = false;
        return;
      }
      const loginRes = await this.$http.post("/api/all/login",
        {
          login_name: this.formdata.login_name,
          password: this.formdata.password,
          terminal: "web",
        },
        {
          headers: { "content-type": "application/x-www-form-urlencoded" },
        }
      );

      if (loginRes.data.state === 0) {
        let userInfo = loginRes.data.result
        if (userInfo) {
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          localStorage.setItem("identity", userInfo.level);
          await this.$axios({
            method: "post",
            url: URL.mianlogin,
            data: {
              unionId: loginRes.data.result.accid,
              nickname: loginRes.data.result.user_nicename,
              redirectUrl: "https://www.rujiaowang.net/mobile",
            },
          }).then((res) => {
            if (this.$route.query.mobile == 'pad') {
              AndroidJs.onUserLogin(
                localStorage.getItem("userInfo")
              );
            }
            if(res.data.state == 0){
              window.location.href = res.data.result.url
            } else {
              console.log(res.data.msg);
            }
          });
        } else {
          this.hasLogin = false;
        }
      } else if (loginRes.data.msg) {
        this.load = false;
        this.$notify(loginRes.data.msg);
      }
      // 调取云信的token
      // const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      // const yunRes = await this.$http.post(
      //   "/api/user/get_user",
      //   { token: userInfo.token },
      //   {
      //     headers: { "content-type": "application/x-www-form-urlencoded" },
      //   }
      // )
    },

    zhuce() {
      this.$router.push("/register");
    },
  },
};
</script> 

<style scoped>
.loginbtn {
  width: 90%;
  height: 45px;
  margin: 20px auto;
  border-radius: 25px;
}
.inpititle {
  width: 90%;
  margin: 10px auto;
  color: #7b7b7b;
  font-size: 14px;
  text-indent: 14px;
}
.warp {
  height: 100vh;
}
.inner {
  position: relative;
}
.login_logo {
  width: 176px;
  height: 56px;
  margin: 0 auto 80px auto;
  padding-top: 20px;
  /* background: url('../assets/logo.png') no-repeat; */
  background-size: cover;
}
.login_form {
  width: 90%;
  height: 42px;
  border-radius: 5px;
  margin: 0 auto 20px;
  background: #f6f7f9;
  border-radius: 23px;
}
.login_form input {
  width: 100%;
  height: 100%;
  outline: 0;
  border: 0;
  text-indent: 1.5em;
  font-size: 15px;
  margin-bottom: 0;
  background: #f6f7f9;
  border-radius: 23px;
}
.person_box {
  margin-top: 100px;
}
.slogn {
  font-size: 15px;
  text-align: center;
  color: #8f8f94;
}
.logo_top {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  padding: 14px 15px;
}
.top_shouye {
  color: #007aff;
}
.top_zhuce {
  color: #007aff;
}

.login_btn {
  text-align: center;
  padding-top: 20px;
}
.login_btn2 {
  text-align: center;
}
.dengl {
  margin-top: 20px;
  line-height: 24px;
  font-size: 16px;
  color: #1989fa;
}
.weixin {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 15px auto;
}
.weixin img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue